package com.iregained.eventapp.pages

import androidx.compose.runtime.*
import com.iregained.eventapp.components.sections.event_booking.styles.CardContainerStyle
import com.iregained.eventapp.theme.toSitePalette
import com.iregained.eventapp.utils.Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Page("/admin/login")
@Composable
fun AdminLoginPage() {
    val ctx = rememberPageContext()
    val palette = ColorMode.current.toSitePalette()
    val coroutineScope = rememberCoroutineScope()

    // Form State
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var errorMessage by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier.fillMaxSize().minHeight(100.vh).backgroundColor(palette.custom.surfaceBackground),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = CardContainerStyle.toModifier().backgroundColor(palette.custom.cardBackground).padding(40.px)
                .maxWidth(400.px).fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // Branding
            Image(
                src = Res.Images.Common.LOGO, modifier = Modifier.height(50.px).margin(bottom = 24.px)
            )

            SpanText(
                text = "Staff Portal Login",
                modifier = Modifier.fontSize(24.px).fontWeight(FontWeight.Bold).color(palette.custom.darkText)
                    .margin(bottom = 24.px)
            )

            // Email Input
            Column(modifier = Modifier.fillMaxWidth().margin(bottom = 16.px)) {
                SpanText("Email Address", modifier = Modifier.fontSize(14.px).margin(bottom = 4.px))
                Input(
                    type = InputType.Email,
                    value = email,
                    onValueChange = { email = it },
                    modifier = Modifier.fillMaxWidth()
                )
            }

            // Password Input
            Column(modifier = Modifier.fillMaxWidth().margin(bottom = 24.px)) {
                SpanText("Password", modifier = Modifier.fontSize(14.px).margin(bottom = 4.px))
                Input(
                    type = InputType.Password,
                    value = password,
                    onValueChange = { password = it },
                    modifier = Modifier.fillMaxWidth()
                )
            }

            // Error Display
            if (errorMessage.isNotEmpty()) {
                SpanText(
                    text = errorMessage, modifier = Modifier.color(Colors.Red).fontSize(14.px).margin(bottom = 16.px)
                )
            }

            // Login Button
            Button(
                onClick = {
                    if (email.isBlank() || password.isBlank()) {
                        errorMessage = "Please enter both email and password."
                        return@Button
                    }

                    isLoading = true
                    errorMessage = ""

                    coroutineScope.launch {
                        try {
                            // Authenticate with Firebase
                            Firebase.auth.signInWithEmailAndPassword(email, password)

                            // On success, redirect to the dashboard
                            ctx.router.navigateTo("/admin/dashboard")
                        } catch (e: Exception) {
                            console.error("Login Error:", e)
                            errorMessage = "Invalid credentials. Please try again."
                        } finally {
                            isLoading = false
                        }
                    }
                }, enabled = !isLoading, modifier = Modifier.fillMaxWidth().padding(topBottom = 12.px)
            ) {
                SpanText(if (isLoading) "Authenticating..." else "Secure Login")
            }
        }
    }
}